import { Box, SxProps, Theme, Zoom } from "@mui/material";
import useDropzone from "hooks/DragAndDrop/useDropzone";
import useIsOver from "hooks/useIsOver";
import useScriptManagementStore from "../../hooks/useScriptManagementStore";
import { QUESTION_DND_TYPE } from "../ScriptQuestions";

interface Props {
  index: number;
  children?: React.ReactNode;
  sx?: SxProps<Theme>;
}

export default function QuestionDropZone({ children, index, sx }: Props) {
  const { handleQuestionDrop } = useScriptManagementStore();
  const { isOver, onMouseEnter, onMouseLeave } = useIsOver();
  const { ref, isOver: isOverDropzone } = useDropzone({
    index,
    dropHandler: handleQuestionDrop,
    accept: [QUESTION_DND_TYPE],
  });

  return (
    <Box
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      ref={ref}
      sx={{
        position: "relative",
        display: "flex",
        flexDirection: "column",
        minHeight: `1rem`,
        height: isOverDropzone ? "3rem" : "1rem",
        width: "100%",
        transition: "height 0.2s",
        color: isOver ? "common.white" : "common.black",
        ...sx,
      }}
    >
      <Zoom in={isOverDropzone}>
        <Box
          sx={{
            position: "absolute",
            height: "4rem",
            width: "100%",
          }}
        >
          <Box
            sx={{
              height: "3rem",
              width: "100%",
              border: ".125rem dashed #bbb",
            }}
          />
        </Box>
      </Zoom>
      {children}
    </Box>
  );
}
